/**
 * Tab directive
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-14:41
 */

lmApp.
  directive('lmShowcase', ['AssetService', 'ShowcaseService', '$timeout', '$interval', '$rootScope', '$compile', '$window', '$templateCache', 'ToastService', 'ModalWindowService',
    function (AssetService, ShowcaseService, $timeout, $interval, $rootScope, $compile, $window, $templateCache, ToastService, ModalWindowService) {
      return {
        templateUrl: 'lm-showcase/lm-showcase.tpl.html',
        restrict: 'E',
        replace: true,
        scope: {
          applicationType: '@',
          showcase: '=',
          isFast: '=?'
        },
        controller: ['$scope', function ($scope) {

          $scope.showcase.isFast = $scope.isFast;
          $scope.rnd = Date.now();

          $scope.showcase._PrivateData = {};
          ShowcaseService.GetAvailableTiles()
            .then(function (collection) {
              $scope.tileTypes = [];

              $scope.tileTypes = collection
                .filter(function (item) {
                  return item.type.indexOf($scope.applicationType) !== -1;
                })
                .map(function (item) {
                  return {
                    type: 'banner',
                    banner: {
                      isNew: true,
                      type: 'widget',
                      isDefaultDefined: true,
                      widget_type: item.type,
                      picture: item.picture.default,
                      bannerName: ShowcaseService._getWidgetName(item.type),
                      widget_attrs: {
                        title: _.find(item.attributes, {id: 'title'}) ? _.find(item.attributes, {id: 'title'}).default : 'Title'
                      }
                    },
                    isNew: true
                  }
                });

              $scope.tileTypes.push({
                type: 'banner',
                banner: {
                  _PrivateData: {
                    icon: 'mdi-view-carousel'
                  },
                  isNew: true,
                  slider_delay: null,
                  type: 'slider',
                  bannerName: 'Slider',
                  isDefaultDefined: true,
                  slider_items: [],
                  widget_type: 'slider'
                }
              });

              $scope.tileTypes = $scope.tileTypes.map(ShowcaseService._ParseTile);
            });

          $scope.preventAction = function (event) {
            if (event && event.stopPropagation) event.stopPropagation();
            if (event && event.preventDefault) event.preventDefault();
          };

          $scope._getBackground = function (showcase) {
            if (showcase.banner) {
              $scope.showcase._PrivateData.background = {};
              $scope.showcase._PrivateData.background = showcase.banner;
              $scope.showcase._PrivateData.background._PrivateData = {};
              $scope.showcase._PrivateData.background._PrivateData.hasNewTile = false;
              $scope.showcase._PrivateData.background._PrivateData.delay = showcase.banner.slider_delay;
              $scope.showcase._PrivateData.background._PrivateData.currentItem = 0;

              $scope.showcase._PrivateData.background.slider_items.forEach(function (item) {
                item.banner = ShowcaseService._ParseWidget(item);
                item._PrivateData.isExpand = true;
                item._PrivateData.isSliderInner = true;
              });

              $scope.showcase._PrivateData.background._PrivateData.showcase_id = showcase.id;

              $scope.bgSlider = $interval(function () {
                if (!$scope.showcase._PrivateData.background._PrivateData.isEdit) {
                  var len = $scope.showcase._PrivateData.background.slider_items.length;
                  var next = $scope.showcase._PrivateData.background._PrivateData.currentItem + 1;
                  $scope.showcase._PrivateData.background._PrivateData.currentItem = (next < len) ? next : 0;
                }
              }, 10000);
            } else {
              $scope.showcase._PrivateData.background = {};
              $scope.showcase._PrivateData.background._PrivateData = {};
              $scope.showcase._PrivateData.background._PrivateData.hasNewTile = false;
              $scope.showcase._PrivateData.background._PrivateData.delay = '';
              $scope.showcase._PrivateData.background._PrivateData.currentItem = 0;
              $scope.showcase._PrivateData.background.slider_items = [];
              $scope.showcase._PrivateData.background._PrivateData.showcase_id = showcase.id;
            }
          };

          $scope._getBackground($scope.showcase);

          if (!$scope.isFast) {

            /**
             *
             * @param tile
             * @param sizes
             * @param event
             */
            $scope.expandTile = function (tile, sizes, event) {
              if (tile._PrivateData.isLocked) {
                return;
              }

              if (tile._PrivateData.isExpand) {
                return;
              }

              if (event && event.stopPropagation) event.stopPropagation();
              if (event && event.preventDefault) event.preventDefault();

              if ($scope.showcase._PrivateData.isLayoutChanged) {

                ToastService.Big({
                  title: 'WARNING',
                  text: '<p class="fs-title">You need to SAVE current layout first!</p>',
                  color: 'amber',
                  icon: 'view-dashboard'
                });

                return;
              }

              var coords = tile._PrivateData.coords;
              if (tile._PrivateData.isExpand) return;
              tile._PrivateData.isExpand = true;

              var $tile = tile.$tile;

              $tile.toggleClass('expand');
              if (!tile.isSupportTile) $tile.toggleClass('tile-hover');
              $tile.css({
                padding: 0,
                bottom: 0,
                left: 0,
                width: sizes.containerWidth,
                height: sizes.containerHeigth,
                'z-index': 1000
              });

              $rootScope.tileExpand = true;
            };

            $scope.collapseTile = function (tile, event) {
              if (event && event.stopPropagation) event.stopPropagation();
              if (event && event.preventDefault) event.preventDefault();

              var $tile = tile.$tile;
              var coords = tile._PrivateData.coords;
              tile._PrivateData.isExpand = false;

              $tile.toggleClass('expand');
              if (!tile.isSupportTile) $tile.toggleClass('tile-hover');
              $tile.css({
                padding: $scope.showcase._Size.margin,
                bottom: $scope.showcase._Size.width * coords.y,
                left: $scope.showcase._Size.width * coords.x,
                width: $scope.showcase._Size.width * coords.span_x,
                height: $scope.showcase._Size.width * coords.span_y,
                'z-index': 10 + coords.index
              });

              $rootScope.tileExpand = false;
            };

            /**
             *
             * @param tile
             */
            $scope.deleteTile = function (tile, event) {
              if ($scope.loading) return;

              if (event && event.stopPropagation) event.stopPropagation();

              if (tile.isNew) {
                var index = $scope.showcase._Grid.indexOf(tile);

                if (index !== -1) {
                  tile.$tile.remove();
                  $scope.showcase._Grid.splice(index, 1);
                  $scope.rebuildGrid();
                }

                return;
              }

              ModalWindowService.Open({
                content: '<p class="fs-headline tc-red-800"> DELETE TILE </p> <p class="fs-title">This action will delete tile permanently. Are You sure? </p>',
                size: {
                  s: 4
                },
                actions: [
                  {
                    title: 'Delete',
                    icon: 'delete',
                    color: 'green',
                    fn: function () {
                      if (tile.isNew) {
                        var index = $scope.showcase._Grid.indexOf(tile);

                        if (index !== -1) {
                          tile.$tile.remove();
                          $scope.showcase._Grid.splice(index, 1);
                          $scope.rebuildGrid();
                        }

                        return;
                      }

                      $scope.loading = true;
                      $rootScope.showLinearProgress('#showcasesLoader');

                      ShowcaseService.DeleteTile(tile)
                        .then(function (response) {
                          $rootScope.hideLinearProgress('#showcasesLoader');
                          $scope.loading = false;
                          ToastService.Small({
                            title: 'Tile successfully deleted',
                            color: 'green',
                            icon: 'delete'
                          });
                          var index = $scope.showcase._Grid.indexOf(tile);
                          tile.$tile.remove();
                          $scope.showcase._Grid.splice(index, 1);
                          $scope.rebuildGrid();
                        })
                        .catch(function (reason) {
                          $rootScope.hideLinearProgress('#showcasesLoader');
                          $scope.loading = false;
                          $rootScope.debugInfo(reason);
                        });
                    }
                  },
                  {
                    title: 'Cancel'
                  }
                ]
              });
            };

            /**
             *
             * @param tile
             */
            $scope.createNewTile = function (tile) {
              if ($scope.loading) return;

              $scope.loading = true;
              $rootScope.showLinearProgress('#showcasesLoader');

              if (tile._PrivateData.type === 'BANNER') {
                ShowcaseService.CreateWidgetTile($scope.showcase, tile, tile.banner)
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $scope.loading = false;
                    ToastService.Small({
                      title: 'Tile successfully created',
                      color: 'green',
                      icon: 'panorama'
                    });
                    tile.isNew = false;
                    tile.id = response.tile.id;
                    $scope.collapseTile(tile);
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Tile creation failed',
                      color: 'red',
                      icon: 'panorama'
                    });
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $scope.loading = false;
                    $rootScope.debugInfo(reason);
                  });
              }

              if (tile._PrivateData.type === 'SLIDER') {
                ShowcaseService.CreateSliderTile($scope.showcase, tile, tile.banner)
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $scope.loading = false;
                    ToastService.Small({
                      title: 'Tile successfully created',
                      color: 'green',
                      icon: 'panorama'
                    });
                    tile.isNew = false;
                    tile.id = response.tile.id;
                    $scope.collapseTile(tile);
                    $rootScope.$broadcast($rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION, $scope.showcase);
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Tile creation failed',
                      color: 'red',
                      icon: 'panorama'
                    });
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $scope.loading = false;
                    $rootScope.debugInfo(reason);
                  });
              }
            };

            $scope.editBgSlider = function (slider, currentItem) {
              if (!slider) return;

              var modalScope = $scope.$new();

              slider._PrivateData.isEdit = true;

              slider._PrivateData.widgetsVariants = $scope.tileTypes.filter(function (widget) {
                return ['asset', 'nop'].indexOf(widget.banner._PrivateData.widget_type) !== -1;
              });

              if (!_.isUndefined(currentItem) && currentItem > -1) slider._PrivateData.currentItem = currentItem;

              modalScope.isFirst = function () {
                return slider._PrivateData.currentItem === 0;
              };

              modalScope.isLast = function () {
                return !(slider._PrivateData.currentItem < slider.slider_items.length - 1);
              };

              modalScope.prevSlider = function (slider) {
                var prev = slider._PrivateData.currentItem - 1;
                slider._PrivateData.currentItem = (prev >= 0) ? prev : 0;
              };

              modalScope.nextSlider = function (slider) {
                var len = slider.slider_items.length;
                var next = slider._PrivateData.currentItem + 1;
                slider._PrivateData.currentItem = (next < len) ? next : next - 1;
              };

              modalScope.isSelectedAsset = function (item, asset) {
                return item._PrivateData.selectedAsset === asset;
              };

              modalScope.close = function (slider) {
                if (modalScope.loading) return;

                modalScope.fullscreenToogle(false);
                slider._PrivateData.isEdit = false;
                ModalWindowService.Close($scope.window, false);
              };

              modalScope.fullscreenToogle = function (state) {
                if (typeof state !== 'undefined') {
                  modalScope.fullscreen = state;
                } else {
                  modalScope.fullscreen = !modalScope.fullscreen;
                }

                ModalWindowService.Fullscreen($scope.window, state);
              };

              modalScope.addSliderItem = function (slider, item) {
                var currentItem = angular.copy(item);

                slider._PrivateData.hasNewTile = true;

                currentItem._PrivateData.isExpand = true;
                currentItem._PrivateData.isSliderInner = true;

                slider.slider_items.push(currentItem);
                slider._PrivateData.currentItem = slider.slider_items.length - 1;

                return slider;
              };

              modalScope.removeSliderItem = function (slider, index) {
                if (modalScope.loading) return;

                if (slider.slider_items[index].banner.isNew) {
                  slider._PrivateData.hasNewTile = false;

                  slider.slider_items.splice(index, 1);
                  var newIndex = slider._PrivateData.currentItem - 1;
                  slider._PrivateData.currentItem = (newIndex < 0 ) ? 0 : newIndex;

                  return;
                }

                modalScope.loading = true;
                $rootScope.showLinearProgress('#showcasesLoader');

                var _ids = slider.slider_items
                  .filter(function (item, i) {
                    return i !== index;
                  })
                  .map(function (item) {
                    return item.id;
                  });

                ShowcaseService.UpdateSlider(slider, _ids)
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    modalScope.loading = false;
                    slider.slider_items.splice(index, 1);
                    var newIndex = slider._PrivateData.currentItem - 1;
                    slider._PrivateData.currentItem = (newIndex > 0 ) ? newIndex : 0;
                    ToastService.Small({
                      title: 'Slider item successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    });
                  })
                  .catch(function (reason) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'Slider item delete failed',
                      color: 'red',
                      icon: 'delete'
                    });
                    modalScope.loading = false;
                    $rootScope.debugInfo(reason);
                  });
              };

              modalScope.createNewSliderItem = function (item) {
                if (modalScope.loading) return;

                var promise;

                modalScope.loading = true;
                $rootScope.showLinearProgress('#showcasesLoader');


                var slider = $scope.showcase._PrivateData.background;

                var _ids = slider.slider_items
                  .map(function (item) {
                    return item.banner.id;
                  });

                if (slider.slider_items.length > 1) {
                  promise = ShowcaseService.UpdateSlider(slider, _ids);
                } else {
                  promise = ShowcaseService.CreateSlider(slider, _ids)
                    .then(function (response) {
                      slider.banner_id = response.slider.id;
                      return ShowcaseService.UpdateShowcase($scope.showcase);
                    });
                }

                promise
                  .then(function (response) {
                    slider._PrivateData.hasNewTile = false;
                    item.isNew = false;
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    modalScope.loading = false;
                    ToastService.Small({
                      title: 'Slider item successfully created',
                      color: 'green',
                      icon: 'view-carousel'
                    });
                    if (item._PrivateData.text) item.text = item._PrivateData.text;
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Slider item creation failed',
                      color: 'red',
                      icon: 'view-carousel'
                    });
                    modalScope.loading = false;
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $rootScope.debugInfo(reason);
                  });
              };

              modalScope.slideReorder = function (slider, item, direction) {
                if (modalScope.loading) return;

                var index = slider.slider_items.indexOf(item);
                var swap = null;

                if (index !== -1 && index + direction >= 0 && index + direction < slider.slider_items.length) {
                  $rootScope.showLinearProgress('#showcasesLoader');
                  modalScope.loading = true;

                  swap = slider.slider_items[index + direction];
                  slider.slider_items[index + direction] = item;
                  slider.slider_items[index] = swap;

                  slider._PrivateData.currentItem += direction;

                  var _ids = _.map(slider.slider_items, 'id');

                  ShowcaseService.UpdateSlider(slider, _ids)
                    .then(function (response) {
                      modalScope.loading = false;

                      $rootScope.hideLinearProgress('#showcasesLoader');
                      ToastService.Small({
                        title: 'Slider\'s items successfully reordered',
                        color: 'green',
                        icon:  'view-carousel'
                      });
                    })
                    .catch(function (reason) {
                      modalScope.loading = false;
                      $rootScope.hideLinearProgress('#showcasesLoader');

                      throw reason;
                    });
                }
              };

              modalScope.slider = slider;
              modalScope._tpl_ = $templateCache.get('lm-showcase/application-android/edit-slider.tpl.html');

              modalScope._tpl_ = $compile(modalScope._tpl_)(modalScope);

              $scope.window = ModalWindowService.Open({
                content: modalScope._tpl_,
                clear: true,
                size: {
                  s: 10
                },
                onInit: function () {
                  if (currentItem === -1) modalScope.addSliderItem(slider);
                },
                onComplete: function () {
                  slider.slider_items.forEach(function (item, index) {
                    if (item.isNew && slider.slider_items.length > 1) {
                      slider.slider_items.splice(index, 1);
                    }
                  });

                  slider._PrivateData.currentItem = 0;
                }
              });
            };
          }

          /**
           *
           * @param showcase_id
           * @returns {*}
           */
          $scope.getTiles = function (showcase_id) {
            if (!showcase_id) return;

            $rootScope.showLinearProgress('#appLoader');
            $scope.loading = true;

            $scope.showcase._Grid = [];

            return ShowcaseService.GetTileByShowcaseId(showcase_id)
              .then(function (tiles) {
                $rootScope.hideLinearProgress('#appLoader');
                $scope.loading = false;
                $scope.showcase._Grid = _.map(tiles, function (tile) {
                  return ShowcaseService._ParseTile(tile);
                });
                return true;
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#appLoader');
                $scope.loading = false;
                $rootScope.debugInfo(reason);
              });
          };
        }],

        /**
         *
         * @param scope
         * @param element
         * @param attrs
         */
        link: function (scope, element, attrs) {
          scope.watchRegister = scope.$watch('showcase', function (newValue, oldValue) {
            if (!_.isEqual(newValue, oldValue) && !_.isEmpty(newValue)) {
              $interval.cancel(scope.bgSlider);
              newValue._PrivateData = {};
              newValue.isFast = scope.isFast;
              scope.getTiles(newValue.id)
                .then(buildGrid);
              scope._getBackground(newValue);
            }
          });

          if (!scope.showcase) return;

          /**
           *
           * @param tile
           */
          function bindDragNDrop(tile) {

            if (!tile.isSupportTile) {
              tile.$tile.bind('dragstart', function (event) {
                $rootScope.$emit("LVL-DRAG-START");
                scope.dragElem = tile;
                tile.isDrag = true;
                if (typeof event.originalEvent.dataTransfer.setDragImage === "function") {
                  event.originalEvent.dataTransfer.setDragImage(angular.element(tile.$tile)[0], 0, tile.$tile.height());
                }
                //console.log('DRAG_START: ', tile);
              });

              tile.$tile.bind('dragend', function (event) {
                $rootScope.$emit("LVL-DRAG-END");
                scope.dragElem = null;
                tile.isDrag = false;
                //console.log('DRAG_END: ', tile);
              });
            }

            tile.$tile.bind('drop', function (event) {
              if (event.stopPropagation) event.stopPropagation();
              if (event.preventDefault) event.preventDefault();

              if (!scope.dragElem || _.isEqual(scope.dragElem._PrivateData.coords, scope.targetElem._PrivateData.coords)) {
                return;
              } else {
                scope.showcase._PrivateData.isLayoutChanged = true;
              }

              var coords_elem = _.cloneWith(scope.dragElem._PrivateData.coords);

              var coords_target = _.cloneWith(scope.targetElem._PrivateData.coords);

              coords_elem.x = scope.targetElem._PrivateData.coords.x;
              coords_elem.y = scope.targetElem._PrivateData.coords.y;

              coords_target.x = scope.dragElem._PrivateData.coords.x;
              coords_target.y = scope.dragElem._PrivateData.coords.y;

              scope.targetElem._PrivateData.coords = coords_target;
              scope.dragElem._PrivateData.coords = coords_elem;

              scope.targetElem.x0 = coords_target.x;
              scope.targetElem.y0 = coords_target.y;
              scope.targetElem.x1 = coords_target.x + coords_target.span_x;
              scope.targetElem.y1 = coords_target.y + coords_target.span_y;

              scope.dragElem.x0 = coords_elem.x;
              scope.dragElem.y0 = coords_elem.y;
              scope.dragElem.x1 = coords_elem.x + coords_elem.span_x;
              scope.dragElem.y1 = coords_elem.y + coords_elem.span_y;

              scope.dragElem._PrivateData.isMoved = true;
              if (!scope.targetElem.isSupportTile) scope.targetElem._PrivateData.isMoved = true;

              reBuildGrid();
            });

            tile.$tile.bind('dragover', function (event) {
              if (event.stopPropagation) event.stopPropagation();
              if (event.preventDefault) event.preventDefault();
              tile.isTarget = true;

              scope.$digest();
            });

            tile.$tile.bind('dragenter', function (event) {
              scope.targetElem = tile;
            });

            tile.$tile.bind('dragleave', function (event) {
              tile.isTarget = false;
            });
          }

          /**
           *
           * @param tile
           * @param type
           */
          function createNewTile(tile, type) {
            var newTile = scope.tileTypes.filter(function (tile) {
              return tile.banner._PrivateData.widget_type === type;
            })[0];

            var size = scope.showcase._Size.newSize;

            if (!newTile || !size) {
              ToastService.Small({
                title: 'Failed create new tile. Contact us for more information.',
                color: 'red',
                icon: 'view-carousel'
              });
              return;
            }

            newTile = angular.copy(newTile);
            var sizes = scope.showcase._Size;
            var $container = scope.showcase.$container;

            scope.collapseTile(tile, sizes);

            newTile.x0 = tile._PrivateData.coords.x;
            newTile.y0 = tile._PrivateData.coords.y;
            newTile.x1 = tile._PrivateData.coords.x + (+size.span_x);
            newTile.y1 = tile._PrivateData.coords.y + (+size.span_y);

            var coords = {
              x: newTile.x0,
              y: newTile.y0,
              span_x: newTile.x1 - newTile.x0,
              span_y: newTile.y1 - newTile.y0,
              index: 10 * newTile.x0 + newTile.y0
            };

            newTile._PrivateData.coords = coords;

            newTile.isNew = true;

            var showcase_tile = $templateCache.get('lm-showcase/tile.tpl.html');

            var tileScope = scope.$new();
            tileScope.tile = newTile;

            showcase_tile = $compile(showcase_tile)(tileScope);
            newTile.$tile = showcase_tile;

            scope.showcase._Grid.push(newTile);

            setCSS(showcase_tile, sizes, coords);

            bindDragNDrop(newTile);

            showcase_tile.appendTo($container);

            reBuildGrid();

            if (newTile.banner._PrivateData.widget_type !== 'ui:logo') {
              scope.expandTile(newTile, scope.showcase._Size);
            } else {
              ShowcaseService.CreateLogoWidget(newTile.banner, 'stockmob')
                .then(function (response) {
                  newTile.banner.id = response.widget.id;

                  scope.createNewTile(newTile);
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  ToastService.Small({
                    title: 'App logo create failed',
                    color: 'red',
                    icon: 'image-area'
                  });
                  $rootScope.debugInfo(reason);
                });
            }
          }

          /**
           * Build new Grid from showcase data
           */
          function buildGrid() {
            var $container = element.find('.grid');
            $container.html('');
            scope.showcase.$container = $container;

            scope.showcase._Size = {
              margin: 5,
              max_x: _.get(_.maxBy(scope.showcase._Grid, 'x1'), 'x1') || 0,
              max_y: _.get(_.maxBy(scope.showcase._Grid, 'y1'), 'y1') || 0,
              containerWidth: $container.width()
            };

            if (scope.showcase._Size.max_x < 12) {
              scope.showcase._Size.width = $container.width() / 12;
            } else {
              scope.showcase._Size.width = $container.width() / (scope.showcase._Size.max_x + 1);
            }

            if (scope.showcase._Size.max_y < 6) {
              $container.css({
                height: scope.showcase._Size.width * (6) + scope.showcase._Size.margin * (6 + 1)
              });
            } else {
              $container.css({
                height: scope.showcase._Size.width * (scope.showcase._Size.max_y + 2) + scope.showcase._Size.margin * (scope.showcase._Size.max_y + 1)
              });
            }

            scope.showcase._Size.containerHeigth = $container.height();

            scope.showcase._Size.sizeTmp = {
              width: $container.width() / 10
            };

            scope.showcase._Size.newSize = {
              span_x: 2,
              span_y: 2
            };

            scope.showcase._Size.newTileTypeCss = {
              height: scope.showcase._Size.sizeTmp.width,
              width: scope.showcase._Size.sizeTmp.width,
              margin: 'auto'
            };

            scope.showcase._Grid.forEach(function (tile, index) {

              var coords = {
                x: tile.x0,
                y: tile.y0,
                span_x: tile.x1 - tile.x0,
                span_y: tile.y1 - tile.y0,
                index: index
              };

              tile._PrivateData.coords = coords;

              var showcase_tile = $templateCache.get('lm-showcase/tile.tpl.html');

              var tileScope = scope.$new();
              tileScope.tile = tile;

              showcase_tile = $compile(showcase_tile)(tileScope);
              tile.$tile = showcase_tile;

              setCSS(showcase_tile, scope.showcase._Size, coords);

              if (!scope.isFast) bindDragNDrop(tile);

              showcase_tile.appendTo($container);
            });

            scope.showcaseBackgroudBanner = {};

            if (!scope.isFast) buildSupportGrid();
          }

          /**
           * Rebuild current showcase build
           */
          function reBuildGrid() {
            var $container = scope.showcase.$container;

            scope.showcase._Size = {
              margin: 5,
              max_x: _.get(_.maxBy(scope.showcase._Grid, 'x1'), 'x1') || 0,
              max_y: _.get(_.maxBy(scope.showcase._Grid, 'y1'), 'y1') || 0,
              containerWidth: $container.width()
            };

            if (scope.showcase._Size.max_x < 12) {
              scope.showcase._Size.width = $container.width() / 12;
            } else {
              scope.showcase._Size.width = $container.width() / (scope.showcase._Size.max_x + 1);
            }

            if (scope.showcase._Size.max_y < 6) {
              $container.css({
                height: scope.showcase._Size.width * (6) + scope.showcase._Size.margin * (6 + 1)
              });
            } else {
              $container.css({
                height: scope.showcase._Size.width * (scope.showcase._Size.max_y + 2) + scope.showcase._Size.margin * (scope.showcase._Size.max_y + 1)
              });
            }

            scope.showcase._Size.containerHeigth = $container.height();

            scope.showcase._Size.sizeTmp = {
              width: $container.width() / 10
            };

            scope.showcase._Size.newSize = {
              span_x: 2,
              span_y: 2
            };

            scope.showcase._Size.newTileTypeCss = {
              height: scope.showcase._Size.sizeTmp.width,
              width: scope.showcase._Size.sizeTmp.width,
              margin: 'auto'
            };

            scope.showcase._Grid.forEach(function (tile, index) {

              if (tile._PrivateData.isExpand) {
                scope.collapseTile(tile, null);
              }

              var coords = {
                x: tile.x0,
                y: tile.y0,
                span_x: tile.x1 - tile.x0,
                span_y: tile.y1 - tile.y0,
                index: index
              };

              tile._PrivateData.coords = coords;

              setCSS(tile.$tile, scope.showcase._Size, coords);
            });

            if (!scope.isFast) buildSupportGrid();
          }

          scope.rebuildGrid = reBuildGrid;

          function setCSS(tile, sizes, coords) {
            tile.css({
              bottom: sizes.width * coords.y,
              left: sizes.width * coords.x,
              padding: sizes.margin,
              width: sizes.width * coords.span_x,
              height: sizes.width * coords.span_y,
              'z-index': 10 * coords.x + coords.y
            });
          }

          /**
           * Build support grid
           */
          function buildSupportGrid() {
            scope.showcase.$container.find('.support-tiles').remove();

            var sizeX = scope.showcase._Size.max_x;
            var sizeY = scope.showcase._Size.max_y;
            var width = scope.showcase._Size.width;
            var margin = scope.showcase._Size.margin;
            var $container = scope.showcase.$container;

            for (var i = 0; i < sizeX + 1; i++) {
              for (var j = 0; j < sizeY + 1; j++) {
                var coords = {
                  x: i,
                  y: j,
                  span_x: 1,
                  span_y: 1,
                  index: 10 * i + j
                };

                var isEmptyPlace = true;

                for (var k = 0; k < scope.showcase._Grid.length; k++) {
                  var tile = scope.showcase._Grid[k]._PrivateData.coords;

                  if (coords.x >= tile.x && coords.x < tile.x + tile.span_x && coords.y >= tile.y && coords.y < tile.y + tile.span_y) {
                    isEmptyPlace = false;
                    break;
                  }
                }

                if (isEmptyPlace) {
                  var showcase_tile = $templateCache.get('lm-showcase/tile-support/tile-support.tpl.html');

                  var tileScope = scope.$new();
                  tileScope.tile = {
                    isSupportTile: true,
                    x0: i,
                    x1: i + 1,
                    y0: j,
                    y1: j + 1,
                    _PrivateData: {
                      coords: coords
                    }
                  };

                  showcase_tile = $compile(showcase_tile)(tileScope);
                  tileScope.tile.$tile = showcase_tile;
                  tileScope.step = 'type';

                  tileScope.setStep = function (type) {
                    $timeout(function () {
                      tileScope.step = type;
                    });
                  };

                  tileScope.isStep = function (type) {
                    return tileScope.step === type;
                  };

                  tileScope.newType = 'ui:back';
                  tileScope.typeSelect = function (tile) {
                    tileScope.newType = tile.banner._PrivateData.widget_type;
                  };

                  tileScope.confirmNew = function (tile) {
                    createNewTile(tile, tileScope.newType);
                  };

                  tileScope.isThisTypeSelected = function (tile) {
                    return tileScope.newType === tile.banner._PrivateData.widget_type;
                  };

                  setCSS(tileScope.tile.$tile, {width: width, margin: margin}, coords);

                  if (!scope.isFast) bindDragNDrop(tileScope.tile);

                  showcase_tile.appendTo($container);
                }
              }
            }
          }

          var _onResize = function () {
            if (scope.resizeTimeout) {
              $timeout.cancel(scope.resizeTimeout);
              scope.resizeTimeout = null;
            }

            scope.resizeTimeout = $timeout(function () {
              reBuildGrid();
            }, 350);
          };

          angular.element($window).bind('resize', _onResize);

          if (scope.showcase.id) {
            scope.getTiles(scope.showcase.id)
              .then(buildGrid);
          }

          scope.$on('$destroy', function () {
            angular.element($window).unbind('resize', _onResize);
            scope.watchRegister();
            $interval.cancel(scope.bgSlider);
          })
        }
      };
    }]);
